/**
 * We tend to represent a lack of context as undefined. But in some cases we like to represent it as a placeholder
 * string (for example in Prometheus metrics) - this is the standard string we suggest using for a lack of context.
 */
export const MISSING_CONTEXT: string = 'unknown'
